import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

const NO_RETRY = ["/auth/login", "/auth/register", "/auth/refresh"];
let refreshing = null;

api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const orig = error.config;
    if (error.response?.status === 401 && orig && !orig._retry && !NO_RETRY.some((u) => orig.url.includes(u))) {
      orig._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        await refreshing;
        refreshing = null;
        return api(orig);
      } catch (e) {
        refreshing = null;
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Algo deu errado. Tente novamente.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg.replace(/^Value error, /, "") : JSON.stringify(e))).join(" ");
  if (typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export async function errorMessage(e) {
  const data = e?.response?.data;
  if (data instanceof Blob) {
    try {
      return formatApiErrorDetail(JSON.parse(await data.text()).detail);
    } catch {
      return "Erro ao gerar arquivo.";
    }
  }
  return formatApiErrorDetail(data?.detail) || e.message;
}

const FILE_TYPES = { pdf: ["Documento PDF", "application/pdf"], zip: ["Arquivo ZIP", "application/zip"], dxf: ["Desenho DXF", "application/dxf"], nc: ["G-code", "text/plain"] };

// Asks where to save (Chrome/Edge). Returns null when the browser can't; throws AbortError if cancelled.
export async function pickSaveTarget(filename) {
  if (!window.showSaveFilePicker) return null;
  const ext = filename.split(".").pop();
  const [description, mime] = FILE_TYPES[ext] || ["Arquivo", "application/octet-stream"];
  try {
    return await window.showSaveFilePicker({ suggestedName: filename, types: [{ description, accept: { [mime]: [`.${ext}`] } }] });
  } catch (e) {
    if (e.name === "AbortError") throw e;
    return null;
  }
}

export async function downloadFile(path, filename, body, handle) {
  const { data } = body
    ? await api.post(path, body, { responseType: "blob" })
    : await api.get(path, { responseType: "blob" });
  if (handle) {
    const w = await handle.createWritable();
    await w.write(data);
    await w.close();
    return;
  }
  const url = URL.createObjectURL(data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 2000);
}
